import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo';

const LogoInverse = (): React.JSX.Element => {
	return <AtlassianLogo appearance="inverse" />;
};

export default LogoInverse;
